import React from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components/macro';

import { useDataStore } from 'state/DataStore';

import Page from 'components/Page';
import ThumbnailGallery from 'components/ThumbnailGallery';

const RenderGallery = observer(() => {
    const dataStore = useDataStore();
    const { unitSlug } = useParams();
    
    const unit = dataStore.getItem('units', 'slug', unitSlug);
    const unitType = dataStore.getItem('unit_types', 'id', unit.acf.unit_type);
    const images = unitType?.acf?.render_gallery || [];

    return (
        <Page>
            <Inner>
                <ThumbnailGallery images={images} />
            </Inner>
        </Page>
    );
});

export default RenderGallery;

const Inner = styled.div`
    width: 100%;
    height: 100%;
    padding: 5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;